/**
 * LogoutButton Component
 */

import './styles.scss';

import * as React from 'react';
import { connect } from 'react-redux';

import { IconSignOut } from '../../images/Icon';
import Button, { ButtonProps } from '../Button';

interface IOwnStateProps {
  logoutUrl: string;
}

interface IOwnProps extends Omit<ButtonProps, 'wrapperComponent' | 'hyperLinkProps'> {
  withIcon?: boolean;
}

type LogoutButtonProps = IOwnProps & IOwnStateProps;

class LogoutButton extends React.Component<LogoutButtonProps, any> {
  static defaultProps: IOwnProps = {
    label: 'Log Out',
  };
  render() {
    const {
      logoutUrl,
      withIcon,
      ...buttonProps
    } = this.props;

    const logOutButtonProps: ButtonProps = {
      hyperLinkProps: {
        href: logoutUrl,
      },
      wrapperComponent: 'a',
      ...buttonProps,
    };

    if (withIcon) {
      logOutButtonProps.icon = <IconSignOut />;
      logOutButtonProps.iconPosition = 'right';
    }

    return (
      <Button {...logOutButtonProps} />
    );
  }
}

const ConnectedLogoutButton = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ authentication }, ownProps) => ({
    logoutUrl: authentication.logoutUrl,
  }),
  () => ({}),
)(LogoutButton);

export default ConnectedLogoutButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LogoutButton/index.tsx